import { defineComponent, ref, computed, watch, onMounted } from 'vue';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiRangeBar",
  props: {
    lastValue: { type: Number, required: true },
    displayLastValue: { type: String, required: false },
    highValue: { type: Number, required: true },
    displayHighValue: { type: String, required: false },
    lowValue: { type: Number, required: true },
    displayLowValue: { type: String, required: false },
    showLabels: { type: Boolean, required: false, default: false }
  },
  setup(__props) {
    const props = __props;
    const marker = ref();
    const markerPositionFromTheLeft = computed(() => {
      if (props.highValue === props.lowValue) {
        return 50;
      }
      return Math.max(Math.min((props.lastValue - props.lowValue) / (props.highValue - props.lowValue) * 100, 100), 0);
    });
    const isUnavailable = computed(() => {
      return !props.lastValue || !props.highValue || !props.lowValue;
    });
    const pointerClassModifier = computed(() => {
      if (isUnavailable.value) {
        return "no-price";
      }
      if (props.lowValue === props.highValue) {
        return "unchanged";
      }
      if (props.lastValue === props.lowValue) {
        return "price-low";
      }
      if (props.lastValue === props.highValue) {
        return "price-high";
      }
      return "default";
    });
    const updateMarkerPositionStyle = () => {
      if (!marker.value) {
        return;
      }
      if (markerPositionFromTheLeft.value > 50) {
        marker.value.style.right = `${100 - markerPositionFromTheLeft.value}%`;
        marker.value.style.left = "";
      } else {
        marker.value.style.right = "";
        marker.value.style.left = `${markerPositionFromTheLeft.value}%`;
      }
    };
    watch(markerPositionFromTheLeft, updateMarkerPositionStyle);
    onMounted(() => {
      updateMarkerPositionStyle();
    });
    return { __sfc: true, props, marker, markerPositionFromTheLeft, isUnavailable, pointerClassModifier, updateMarkerPositionStyle };
  }
});

export { _sfc_main as default };
